import { Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { fetchSmbTrackId } from "../api/smb";
import { identifyUser } from "../mixpanel";
import {
  PageWrapper,
  TopSection,
  TopSectionMain,
  Slider,
  SliderBox,
  ProvidersSection,
  BestRateSection,
  BestRateSlider,
  RateSliderBox,
  ProgramSection,
  ProgramSectionContent,
  SectionImg,
  SectionRow,
} from "../components/styles/SmbLoadingPage.styled";
import { ValidateAddress } from "../ValidateAddressSmb";
import Footer from "../components/footer";

const SmbLandingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const externalTrackId =
      urlParams.get("externalTrackId") || urlParams.get("clickId");
    const trafficSource = urlParams.get("trafficSource");
    if (externalTrackId)
      sessionStorage.setItem("externalTrackId", externalTrackId);
    if (trafficSource) sessionStorage.setItem("trafficSource", trafficSource);
    if (sessionStorage.getItem("smbGetQuote")) {
      sessionStorage.removeItem("smbGetQuote");
      navigate("/smb/info");
    }

    const getTrackId = async () => {
      const trackId = await fetchSmbTrackId();
      if (trackId?.response?.TrackId) {
        sessionStorage.setItem("smbTrackId", trackId.response.TrackId);
        identifyUser(trackId.response.TrackId);
      }
    };

    const storedTrackId = sessionStorage.getItem("smbTrackId");
    if (!storedTrackId) {
      getTrackId();
    } else {
      identifyUser(storedTrackId);
    }
  }, [navigate]);

  const SliderData = [
    {
      title: "Step 1",
      description: "Instant quotes from top suppliers",
      icon: <img src="/images/image-3.png" alt="step1" />,
    },
    {
      title: "Step 2",
      description: "No upfront costs or hidden fees",
      icon: <img src="/images/image-2.png" alt="step2" />,
    },
    {
      title: "Step 3",
      description: "Trusted partnerships with licensed providers",
      icon: <img src="/images/image-1.png" alt="step3" />,
    },
    {
      title: "Step 4",
      description: "Mobile-friendly access and digital signing",
      icon: <img src="/images/image.png" alt="step4" />,
    },
  ];

  const RateSliderData = [
    {
      title: "Real-Time Access",
      description:
        "Instantly view live electricity rates from top-tier suppliers in your area. Our system continuously updates pricing to ensure you see the most current offers available.",
      icon: <img src="/images/vector-1.png" alt="step1" width={287} />,
    },
    {
      title: "Transparent Pricing",
      description:
        "See the exact rates and contract terms before you commit. No surprises, no hidden fees, no complicated pricing structures.",
      icon: <img src="/images/vector-2.png" alt="step2" width={278} />,
    },
    {
      title: "Tailored Solutions",
      description:
        "We match plans based on your usage profile and location, ensuring you get the most suitable energy solution for your specific business needs.",
      icon: <img src="/images/vector-3.png" alt="step3" width={234} />,
    },
    {
      title: "Same-Day Signing",
      description:
        "Secure and digitally sign your preferred contract within minutes. Our streamlined process gets you enrolled quickly without service interruptions.",
      icon: <img src="/images/vector-4.png" alt="step4" width={305} />,
    },
  ];

  return (
    <>
      {/* <Header /> */}
      <PageWrapper>
        <div style={{ position: "absolute", top: "30px", left: "60px" }}>
          <Link to="/" style={{ marginTop: "35px" }}>
            <img src="/images/logo.png" height="60" alt="Logo" />
          </Link>
        </div>
        <Container>
          <TopSection>
            <TopSectionMain>
              <div className="text-box">
                <h1>
                  Find the Right Electricity Plan for{" "}
                  <span style={{ color: "#81B9FF" }}>Your Texas Business</span>
                </h1>
                <div style={{ width: "540px", maxWidth: "90vw" }}>
                  <ValidateAddress
                    onsubmit={() => {
                      navigate("/smb/info");
                    }}
                  />
                </div>
              </div>
              <div style={{ position: "relative", marginLeft: "20px" }}>
                <div className="desc-box">
                  We scan the market daily so your business always gets the best
                  deal.
                </div>
                <img src="/images/icon-homepage.png" alt="" />
              </div>
            </TopSectionMain>
          </TopSection>
        </Container>
      </PageWrapper>
      <Container>
        <Slider>
          {SliderData.map((item, index) => (
            <SliderBox key={index}>
              {item.icon}
              {item.description}
            </SliderBox>
          ))}
        </Slider>
      </Container>
      <ProvidersSection>
        <Container>
          <div className="title">Our Trusted Energy Providers</div>
          <div className="logos-row">
            <div className="logo-item">
              <img src="/providers/apg-e.png" alt="APG&E" />
            </div>
            <div className="logo-item">
              <img src="/providers/chariot.png" alt="Chariot Energy" />
            </div>
            <div className="logo-item">
              <img src="/providers/atlantex.png" alt="AEP Energy" />
            </div>
            <div className="logo-item">
              <img src="/providers/constellation.png" alt="Constellation" />
            </div>
          </div>
        </Container>
      </ProvidersSection>
      <BestRateSection>
        <Container>
          <div className="title-box">
            <div className="title">Get the Best Price Every Time</div>
            <div className="desc">
              Our automated pricing engine constantly updates to give you
              unbeatable deals based on live market trends.
            </div>
          </div>
          <BestRateSlider>
            <div className="marquee">
              {RateSliderData.map((item, index) => (
                <RateSliderBox key={index}>
                  <div className="icon-box">{item.icon}</div>
                  <div className="text-box">
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                </RateSliderBox>
              ))}
            </div>
          </BestRateSlider>
        </Container>
      </BestRateSection>

      <ProgramSection>
        <Container>
          <h4>How It Works</h4>
          <h3>Simple 3-Step Process</h3>
          <SectionRow>
            <ProgramSectionContent>
              <div className="step-title">1</div>
              <div>
                <h2>Share Your Business Info</h2>
                <p>
                  Enter your business details and energy usage information to
                  get personalized quotes from top energy providers in your
                  area.
                </p>
              </div>
            </ProgramSectionContent>
            <SectionImg>
              <img src="/images/icon-step-1.png" alt="" />
            </SectionImg>
          </SectionRow>
          <SectionRow>
            <ProgramSectionContent>
              <p className="step-title">2</p>
              <div>
                <h2>Compare & Choose</h2>
                <p>
                  View real-time competitive rates and plans tailored to your
                  business needs. Compare options with complete transparency and
                  no hidden fees.
                </p>
              </div>
            </ProgramSectionContent>
            <SectionImg>
              <img src="/images/icon-step-2.png" alt="" />
            </SectionImg>
          </SectionRow>
          <SectionRow style={{ marginBottom: "0" }}>
            <ProgramSectionContent>
              <p className="step-title">3</p>
              <div>
                <h2>Sign & Switch</h2>
                <p>
                  Digitally sign your chosen plan in minutes using our secure
                  platform. We handle all the switching details with no service
                  interruptions.
                </p>
              </div>
            </ProgramSectionContent>
            <SectionImg>
              <img src="/images/icon-step-3.png" alt="" />
            </SectionImg>
          </SectionRow>
        </Container>
      </ProgramSection>
      <Footer></Footer>
    </>
  );
};

export default SmbLandingPage;
